import { TransformsList } from 'cio/utils/analytics/transforms';

const Transforms: TransformsList = {
  userData({ data }) {
    return {
      'Account Id': data.account_id,
      'Requester Name': data.requester,
      'Requester Email': data.requester_email,
      'Requester User Id': data.requester_user_id,
      'Current Plan': data.current_plan,
      'Requested Plan': data.requested_plan,
    };
  },
  fieldInput({ data }) {
    return {
      ...Transforms.userData({ data }),
      'Field Name': data.field,
    };
  },
};

export default Transforms;
